import "./App.css";
import Home from "./pages/Home";
import Login from "./pages/Login";
import TopicDetails from "./pages/TopicDetails";
import ProtectedLayout from "./components/ProtectedLayout";
import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import NotFound from "./pages/NotFound";

import Welcome from "./pages/Welcome";

/* All Modules */
import Curriculum from "./pages/Curriculum";
import ModulesProgressReport from "./pages/reports/ModulesProgressReport";
import QuizPage from "./components/QuizPage";
import QuizPageEnhanced from "./components/QuizPageEnhanced";
import ResultPage from "./components/ResultPage";

import AssessmentSubmission from "./pages/AssessmentSubmission"

import Planner from "./pages/Planner";
import QNA from "./pages/qna/QuestionForum";
import MyProgress from "./pages/MyProgress";
import ProgressReport from "./pages/reports/ProgressReport";
import Report from "./pages/reports/SummaryReport"


/* User Settings */
import ProtectedRoute from "./components/ProtectedRoute";
import Profile from "./pages/Profile";
import MyNotes from "./pages/MyNotes";
import Verify from "./pages/Verify";


/* Admin Panel */
import Admin from "./pages/admin/RegisterStudent";
import UpdateAttendance from "../src/pages/admin/UpdateAttendance";
import Feedback from "../src/pages/admin/Feedback";
import AddModule from "./pages/admin/AddModule";
import UpdateStudentMarks from "./pages/admin/UpdateMarks";
import AssessmentSubmissionAdmin from "./pages/admin/AssessmentSubmissionAdmin";
import SharePage from "./pages/admin/SharePage";
import QNAAdminPanel from "./pages/admin/QNAAdminPanel";
import PDFSummaryReport from "./pages/admin/PDFSummaryReport"




import './styles/markdown.css';

function App() {
  return (
    <AuthProvider>
      <Toaster />
      <Router>
        <Routes>
        {/* <Route path="/report/:orgCode" element={<Report />} /> */}
          <Route path="/summary_report/:orgCode" element={<Report />} />
          <Route path="/app/admin_panel/:orgCode" element={<Admin />} />
          <Route path="/app/update-attendance" element={<UpdateAttendance/>}/>
          <Route path="/app/add-module" element={<AddModule/>}/>
          <Route path="/app/update-marks" element={<UpdateStudentMarks/>}/>
          <Route path="/app/share_app" element={<SharePage/>}/>
		      <Route path="/app/feedback" element={<Feedback />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/" element={<ProtectedLayout />}>
          <Route index element={<Home />} />
			
			
            <Route path="profile" element={<Profile />} />
            <Route path="planner" element={<Planner />} />
            <Route path="progress_report" element={<ProgressReport />} />
            <Route path="notes" element={<MyNotes />} />
            <Route path="progress" element={<MyProgress />} />
            <Route path="qna" element={<QNA />} />
            <Route path="program_milestone" element={<Curriculum />}>
             <Route index element={<ModulesProgressReport />} />
              <Route path="module-progress" element={<ModulesProgressReport />}/>
              <Route path=":topicId/:subtopicId/:linkId?" element={<TopicDetails />}/>
            </Route>
            <Route path="assessment_submission" element={<AssessmentSubmission />} />
            
            <Route path="/summary_report" element={<Report />} />
            <Route element={<ProtectedRoute />}>	        
               <Route path="/admin" element={<Admin />} />             
                <Route path="/update-attendance" element={<UpdateAttendance/>}/>
                <Route path="/add-module" element={<AddModule/>}/>
                
                <Route path="/update-marks" element={<UpdateStudentMarks/>}/>
                 <Route path="/submissions-admin" element={<AssessmentSubmissionAdmin/>}/>
                <Route path="/feedback" element={<Feedback />} />
                <Route path="/share" element={<SharePage/>}/>
                <Route path="/qnaadmin-panel" element={<QNAAdminPanel/>}/>
                <Route path="/pdf_summary_report" element={<PDFSummaryReport />} />
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
		  <Route path="practice_quiz/:subject/:quiz_file_name/:id" element={<QuizPage />} />
      
      <Route path="/assessment_quiz/:program_name/:course_name/:quiz_file_name/:id" element={<QuizPageEnhanced />}
/>
		  <Route path='/result' element={<ResultPage/>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
